import type { BoxProps } from '../Core';
import { Wrapper } from './styles';

export function EmptyView(props: BoxProps) {
  return <Wrapper {...props} />;
}
